export default {
	profile: {
		name: 'Konto',

		icon: 'far fa-user-circle',

		user: '@:common.user',

		user_name: 'Benutzername',

		account: 'Konto',

		administration: '@:common.administration',

		last_login: 'Letzte Anmeldung',

		last_data_update: 'Letzte Datenaktualisierung',

		change_password: 'Passwort ändern',

		my_accounts: 'Meine Konten',

		my_accounts_empty: 'Keine Konten zugeordnet.',

		my_accounts_error: 'Konten konnten nicht geladen werden.',

		my_accounts_no_building: 'Kein Gebäude zugeordnet',

		my_accounts_no_unit: 'Konten ohne Einheit',

		my_accounts_contact: 'Ansprechpartner',

		my_accounts_no_journals: 'Keine Buchungen vorhanden.',

		my_accounts_journals_error: 'Buchungen konnten nicht geladen werden.',

		my_accounts_no_results: 'Keine Konten entsprechen den Filtern.',

		my_accounts_filter_building: 'Gebäude',

		my_accounts_filter_unit: 'Einheit',

		balance: 'Saldo',

		personal_data_update: 'Persönliche Daten aktualisieren',

		delete_profile_picture: 'Profilebild Löschen',

		send_messages: 'Versendete Nachrichten',

		email_registered_multiple_notice:
			'Ihre E-Mail Adresse ist bei mehreren Verwaltungen hinterlegt.\n' +
			'Über die nachfolgende Auswahl können Sie die Daten wechseln.',

		explanation:
			'Treffen Sie hier bitte die Auswahl für welche Art von Dokumenten oder ' +
			'Informationen Sie Benachrichtigungen per E-Mail erhalten möchten. ' +
			'Der Versand der Benachrichtigung erfolgt ausschließlich an Ihre hinterlegte E-Mail Adresse.',

		warning:
			'Bitte beachten Sie, dass Sie trotz Ihrer getroffenen Einstellungen, ' +
			'Benachrichtigungen über dringende Informationen erhalten könnten.',

		switch: {
			propertyDocs: 'Dokumente zu Ihren Liegenschaft(en)',
			unitDocs: 'Dokument zu Ihren Einheit(en)',
			personDocs: 'Persönliche Dokumente',
			notes: 'Notizen',
			consumption:
				'@:component.consumption.consumptionInformation / Zählerstandserfassung',
			reports: 'Informationen zu Meldungen',
		},

		updateRequest: {
			title: 'Persönliche Daten aktualisieren',
			birthday: 'Geburtstag',
			reset: '@:common.reset',
			duplicateWarning:
				'Es existiert bereits eine Anfrage. Bevor diese nicht verarbeitet wurde, ' +
				'kann keine neue Anfrage gestartet werden. Sie können diese löschen ' +
				'und eine neue Anfrage beginnen.',
			sent: 'Ihre Anfrage wurde gesendet.',
			discardConfirm: 'Möchten Sie den Antrag wirklich verwerfen?',
			emailTooltip:
				'Die aktuell zur Anmeldung verwendete E-Mail-Adresse kann nicht geändert werden. ' +
				'Falls diese E-Mail-Adresse geändert werden muss, fügen Sie bitte eine entsprechende Anweisung im Kommentarfeld hinzu.',
		},
	},
}
